
import Home from './Default/Home';


const AppRoutesLogin = [
  {
    index: true,
        element: <Home />
  }
   
];

export default AppRoutesLogin;
